var map = {
	"./desktop": [
		93611,
		9,
		46066,
		82587,
		99670,
		31139,
		67142,
		21603,
		23255,
		49510,
		78878,
		67967,
		87795,
		11024,
		10927,
		47871,
		59721,
		71831,
		28376,
		83349,
		32205,
		88515
	],
	"./desktop/": [
		93611,
		9,
		46066,
		82587,
		99670,
		31139,
		67142,
		21603,
		23255,
		49510,
		78878,
		67967,
		87795,
		11024,
		10927,
		47871,
		59721,
		71831,
		28376,
		83349,
		32205,
		88515
	],
	"./desktop/CoronaVirus": [
		60185,
		9,
		46066,
		31139,
		67142,
		23255,
		47871,
		59721,
		71831,
		28376,
		83349,
		32205,
		13506
	],
	"./desktop/CoronaVirus.js": [
		60185,
		9,
		46066,
		31139,
		67142,
		23255,
		47871,
		59721,
		71831,
		28376,
		83349,
		32205,
		13506
	],
	"./desktop/CoronaVirus.scss": [
		75497,
		7,
		29960
	],
	"./desktop/index": [
		93611,
		9,
		46066,
		82587,
		99670,
		31139,
		67142,
		21603,
		23255,
		49510,
		78878,
		67967,
		87795,
		11024,
		10927,
		47871,
		59721,
		71831,
		28376,
		83349,
		32205,
		88515
	],
	"./desktop/index.js": [
		93611,
		9,
		46066,
		82587,
		99670,
		31139,
		67142,
		21603,
		23255,
		49510,
		78878,
		67967,
		87795,
		11024,
		10927,
		47871,
		59721,
		71831,
		28376,
		83349,
		32205,
		88515
	],
	"./mobile": [
		76450,
		9,
		46066,
		82587,
		41484,
		67142,
		21603,
		23255,
		49510,
		78878,
		67675,
		25018,
		37063,
		94935,
		47871,
		17511,
		12803,
		63939
	],
	"./mobile/": [
		76450,
		9,
		46066,
		82587,
		41484,
		67142,
		21603,
		23255,
		49510,
		78878,
		67675,
		25018,
		37063,
		94935,
		47871,
		17511,
		12803,
		63939
	],
	"./mobile/CoronaVirus": [
		70764,
		9,
		46066,
		82587,
		41484,
		67142,
		21603,
		23255,
		78878,
		94935,
		47871,
		17511,
		12803,
		49699
	],
	"./mobile/CoronaVirus.js": [
		70764,
		9,
		46066,
		82587,
		41484,
		67142,
		21603,
		23255,
		78878,
		94935,
		47871,
		17511,
		12803,
		49699
	],
	"./mobile/CoronaVirus.scss": [
		92115,
		7,
		85997
	],
	"./mobile/index": [
		76450,
		9,
		46066,
		82587,
		41484,
		67142,
		21603,
		23255,
		49510,
		78878,
		67675,
		25018,
		37063,
		94935,
		47871,
		17511,
		12803,
		63939
	],
	"./mobile/index.js": [
		76450,
		9,
		46066,
		82587,
		41484,
		67142,
		21603,
		23255,
		49510,
		78878,
		67675,
		25018,
		37063,
		94935,
		47871,
		17511,
		12803,
		63939
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(2).map(__webpack_require__.e)).then(() => {
		return __webpack_require__.t(id, ids[1] | 16)
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 47938;
module.exports = webpackAsyncContext;